module.exports = __webpack_public_path__ + "static/img/otp_im.fb72298.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/otp_im.svg
// module id = y4rM
// module chunks = 7